import ReactMarkdown from "react-markdown";
import remarkBreaks from "remark-breaks";
import remarkGfm from "remark-gfm";

interface MarkdownProps {
  source: string;
  className?: string;
}

/**
 * Render trusted markdown to React. Used for feedback / feature-request
 * bodies, which are authored by SSO-gated DataCampers (or by MCP agents
 * acting on their behalf) and frequently arrive as Markdown.
 *
 * Raw HTML is intentionally not rendered — `react-markdown` ignores it by
 * default, which is the safe behaviour we want even though the audience is
 * internal. Links are forced to open in a new tab with `noopener noreferrer`.
 *
 * `remark-breaks` is enabled so single newlines from a plain textarea (the
 * UI submission path) render as visible line breaks, matching the behaviour
 * of the previous `whitespace-pre-wrap` rendering.
 */
export function Markdown({ source, className }: MarkdownProps): JSX.Element {
  return (
    <div className={`prose prose-sm max-w-none ${className ?? ""}`}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm, remarkBreaks]}
        components={{
          a: ({ node: _node, href, children, ...rest }) => (
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              {...rest}
            >
              {children}
            </a>
          ),
        }}
      >
        {source}
      </ReactMarkdown>
    </div>
  );
}
